import React from 'react';

interface Props {
  src: string;
  alt: string;
  size: IconSize;
}

export enum IconSize {
  SMALL = 24,
  MEDIUM = 30,
  LARGE = 48
}

export const ObjectIcon: React.FC<Props> = ({src, alt, size}: Props) => {
  return (
    <img height={size} width={size} src={src} alt={alt} title={alt} />
  );
};
